export enum ProfessionalsDownloadsDocumentType {
  Materials = 'materials',
  Magazines = 'magazines',
  Care = 'care',
  Certificates = 'certificates',
  Press = 'press',
}
